import { ActionConfig, ActionContext } from '../../../logic/types'
import { ClaimPointsRewardsAction } from '../types'
import { pointsSparkRewardsConfig } from '@/config/contracts-generated'
import { getContractAddress } from '@/domain/hooks/useContractAddress'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { convertPointsRewardQueryKey } from '@/features/points/dialogs/convert-points-dialog/logic/convertPointsRewardQueryOptions'

export function createClaimPointsRewardsActionConfig(
  action: ClaimPointsRewardsAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context
  const { epoch, token, cumulativeAmount, merkleRoot, merkleProof } = action

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        address: getContractAddress(pointsSparkRewardsConfig.address, chainId),
        abi: pointsSparkRewardsConfig.abi,
        functionName: 'claim',
        args: [BigInt(epoch), account, token.address, token.toBigInt(cumulativeAmount), merkleRoot, merkleProof],
      })
    },

    invalidates: () => [
      getBalancesQueryKeyPrefix({ chainId, account }),
      convertPointsRewardQueryKey({ account, chainId }),
    ],
  }
}
